var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StickyTable',{staticClass:"progress-table",attrs:{"header":_vm.header,"data":_vm.data,"annotations":_vm.annotations,"loading":_vm.busy},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var ref_item = ref.item;
var name = ref_item.name;
var aggregatedValue = ref_item.aggregatedValue;
return [_c('tr',[_c('Cell',{staticClass:"name",attrs:{"th":"","horizontal":"","vertical":""}},[_vm._v(_vm._s(name))]),_vm._v(" "),_vm._l((aggregatedValue),function(item,key){return _c('Cell',{key:key,attrs:{"th":"","vertical":""}},[_vm._v("\n        "+_vm._s(item)+"\n      ")])})],2)]}},{key:"row",fn:function(ref){
var ref_item = ref.item;
var name = ref_item.name;
var aggregatedValue = ref_item.aggregatedValue;
var ref_annotation = ref.annotation;
var suffix = ref_annotation.suffix;
var formatter = ref_annotation.formatter;
var index = ref.index;
return [_c('tr',{key:index},[_c('Cell',{staticClass:"name",attrs:{"horizontal":""}},[_vm._v(_vm._s(name))]),_vm._v(" "),_vm._l((aggregatedValue),function(value,key){return _c('Cell',{key:key},[_vm._v("\n        "+_vm._s(formatter(value))),_c('span',{staticClass:"suffix"},[_vm._v(_vm._s(suffix))])])})],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }